import React from 'react';
import PropTypes from 'prop-types';
import { injectTestId } from '@cvent/nucleus-test-automation';

/**
 * The containing wrapper element around individual Pagination items.
 * Presentation and accessibility only
 */
export default class Container extends React.Component {
  static propTypes = {
    /** Pagination items */
    children: PropTypes.node.isRequired,
    /** aria-label or accessibilityLabel attribute */
    accessibilityLabel: PropTypes.string,
    /** aria-hidden or accessible attribute */
    accessible: PropTypes.bool,
    /** Text direction */
    isRtl: PropTypes.bool,
    /** For e2e tests (maps to `data-cvent-id`) */
    testID: PropTypes.string
  };

  render() {
    const {
      children,
      accessibilityLabel,
      accessible,
      isRtl,
      testID
    } = this.props;

    return (
      <nav
        aria-hidden={!accessible}
        aria-label={accessibilityLabel}
        css={getContainerStyles({ isRtl })}
        role="navigation"
        {...injectTestId(testID)}
      >
        {children}
      </nav>
    );
  }
}

function getContainerStyles({ isRtl }) {
  return {
    direction: isRtl ? 'rtl' : 'ltr',
    display: 'inline-flex',
    padding: '0 2px'
  };
}
